// extracted by mini-css-extract-plugin
export default {"container":"Thumbnail_container__MKiRb","title_area":"Thumbnail_title_area__lKVZZ","thumbnail_area":"Thumbnail_thumbnail_area__4rx3z","thumbnail":"Thumbnail_thumbnail__UQb-h"};